
/* Tropikol theme - global.js */
(function () {
  'use strict';

  /* Mobile navigation */
  function initNav() {
    var burger = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    var overlay = document.querySelector('[data-nav-overlay]');

    if (!burger || !nav) return;

    function closeNav() {
      nav.classList.remove('is-open');

      if (overlay) {
        overlay.classList.remove('is-open');
      }

      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    function openNav() {
      nav.classList.add('is-open');

      if (overlay) {
        overlay.classList.add('is-open');
      }

      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    burger.addEventListener('click', function () {
      if (nav.classList.contains('is-open')) {
        closeNav();
      } else {
        openNav();
      }
    });

    if (overlay) {
      overlay.addEventListener('click', closeNav);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeNav();
      }
    });

    nav.querySelectorAll('[data-has-submenu] > a').forEach(
      function (link) {
        link.addEventListener('click', function (event) {
          if (
            window.matchMedia('(max-width: 768px)').matches
          ) {
            var submenu = link.parentElement.querySelector(
              '.header__submenu'
            );

            if (submenu) {
              event.preventDefault();

              submenu.style.display =
                submenu.style.display === 'block'
                  ? 'none'
                  : 'block';
            }
          }
        });
      }
    );
  }

  /* Standard quantity steppers for other products */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(
      function (wrap) {
        var input = wrap.querySelector('input');

        if (!input) return;

        wrap.querySelectorAll('[data-qty-btn]').forEach(
          function (button) {
            button.addEventListener('click', function () {
              var step = parseInt(
                button.getAttribute('data-qty-btn'),
                10
              );

              if (isNaN(step)) return;

              var minimum = parseInt(
                input.getAttribute('min'),
                10
              );

              if (isNaN(minimum)) minimum = 1;

              var current = parseInt(input.value, 10);

              if (isNaN(current)) current = minimum;

              var maximum = parseInt(
                input.getAttribute('max'),
                10
              );

              var newValue = Math.max(
                minimum,
                current + step
              );

              if (!isNaN(maximum)) {
                newValue = Math.min(maximum, newValue);
              }

              input.value = newValue;

              input.dispatchEvent(
                new Event('change', { bubbles: true })
              );
            });
          }
        );
      }
    );
  }

  /* Sticky header */
  function initSticky() {
    var header = document.querySelector(
      '[data-sticky-header]'
    );

    if (!header) return;

    function updateHeader() {
      header.classList.toggle(
        'is-stuck',
        window.scrollY > 8
      );
    }

    window.addEventListener(
      'scroll',
      updateHeader,
      { passive: true }
    );

    updateHeader();
  }

  /* Coco Coir pack selector and quantity picker */
  function initBlockPricing() {
    document.querySelectorAll('[data-block-picker]').forEach(
      function (picker) {
        var packSelect = picker.querySelector(
          '[data-pack-size]'
        );

        var packCount = picker.querySelector(
          '[data-pack-count]'
        );

        var minusButton = picker.querySelector(
          '[data-pack-minus]'
        );

        var plusButton = picker.querySelector(
          '[data-pack-plus]'
        );

        var cartQuantity = picker.querySelector(
          '[data-cart-block-quantity]'
        );

        var unitDisplay = picker.querySelector(
          '[data-block-unit-price]'
        );

        var blockDisplay = picker.querySelector(
          '[data-block-quantity]'
        );

        var totalDisplay = picker.querySelector(
          '[data-block-total]'
        );

        if (
          !packSelect ||
          !packCount ||
          !minusButton ||
          !plusButton ||
          !cartQuantity ||
          !unitDisplay ||
          !blockDisplay ||
          !totalDisplay
        ) {
          return;
        }

        var priceInPence = Number(
          picker.getAttribute('data-base-price')
        );

        if (
          !Number.isSafeInteger(priceInPence) ||
          priceInPence <= 0
        ) {
          return;
        }

        var allowedAmounts = [2, 4, 6, 8, 10];

        function formatMoney(pence) {
          return '£' + (pence / 100).toFixed(2);
        }

        function getPackSize() {
          var size = parseInt(packSelect.value, 10);

          if (allowedAmounts.indexOf(size) === -1) {
            size = 2;
            packSelect.value = '2';
          }

          return size;
        }

        function getPackCount() {
          var count = Number(packCount.value);

          if (
            !Number.isSafeInteger(count) ||
            count < 1
          ) {
            count = 1;
          }

          return count;
        }

        function updatePricing() {
          var size = getPackSize();
          var count = getPackCount();

          var totalBlocks = size * count;

          if (!Number.isSafeInteger(totalBlocks)) {
            return;
          }

          var totalPence = totalBlocks * priceInPence;

          if (!Number.isSafeInteger(totalPence)) {
            return;
          }

          packCount.value = String(count);
          cartQuantity.value = String(totalBlocks);

          unitDisplay.textContent = formatMoney(
            priceInPence
          );

          blockDisplay.textContent = String(totalBlocks);

          totalDisplay.textContent = formatMoney(
            totalPence
          );

          minusButton.disabled = count <= 1;

          Array.from(packSelect.options).forEach(
            function (option) {
              var optionSize = parseInt(
                option.value,
                10
              );

              if (
                allowedAmounts.indexOf(optionSize) === -1
              ) {
                return;
              }

              option.textContent =
                optionSize +
                ' blocks: ' +
                formatMoney(optionSize * priceInPence);
            }
          );
        }

        /* Restrict Amount dropdown */
        Array.from(packSelect.options).forEach(
          function (option) {
            if (
              allowedAmounts.indexOf(
                parseInt(option.value, 10)
              ) === -1
            ) {
              option.remove();
            }
          }
        );

        if (
          allowedAmounts.indexOf(
            parseInt(packSelect.value, 10)
          ) === -1
        ) {
          packSelect.value = '2';
        }

        /* Minus button */
        minusButton.addEventListener(
          'click',
          function () {
            packCount.value = String(
              Math.max(1, getPackCount() - 1)
            );

            updatePricing();
          }
        );

        /* Plus button */
        plusButton.addEventListener(
          'click',
          function () {
            packCount.value = String(
              getPackCount() + 1
            );

            updatePricing();
          }
        );

        /* Pack size changes */
        packSelect.addEventListener(
          'change',
          updatePricing
        );

        /* Manual pack quantity changes */
        packCount.addEventListener(
          'change',
          updatePricing
        );

        /* Keep cart quantity synchronised on submit */
        var productForm = picker.closest('form');

        if (productForm) {
          productForm.addEventListener(
            'submit',
            function (event) {
              updatePricing();

              if (!productForm.checkValidity()) {
                event.preventDefault();
                productForm.reportValidity();
              }
            }
          );
        }

        updatePricing();
      }
    );
  }

  /* Initialise all theme functions */
  function initTheme() {
    initNav();
    initQty();
    initSticky();
    initBlockPricing();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initTheme
    );
  } else {
    initTheme();
  }
})();
